const PLAN_URL = process.env.API_URL + '/xugarhero/diet';
const CALENDAR_PLAN_URL = process.env.API_URL + '/xugarhero/diet/calendar';
const FOOD_URL = process.env.API_URL + '/xugarhero/food_composition';
const FOOD_INFO_URL = process.env.API_URL + '/v2/xugarhero/food_composition/id/';
const USER_URL = process.env.API_URL + '/xugarhero/user';

const getPlans = (context, userId, type, active, template) => {
  return new Promise((resolve, reject) => {
    context.$http.get(PLAN_URL, {params: {userId, type, active, template}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getAllUserPlans = (context, userId) => {
  return new Promise((resolve, reject) => {
    context.$http.get(PLAN_URL + '/' + userId)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getTemplates = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(PLAN_URL, {params: {template: true}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const deletePlan = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(PLAN_URL, {params: {id}})
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const updatePlan = (context, plan) => {
  return new Promise((resolve, reject) => {
    context.$http.put(PLAN_URL, plan)
      .then((response) => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const createPlan = (context, plan) => {
  return new Promise((resolve, reject) => {
    context.$http.post(PLAN_URL, plan)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getFoodList = (context, language) => {
  return new Promise((resolve, reject) => {
    context.$http.get(FOOD_URL, {params: {language}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getFoodInfo = (context, id, language) => {
  return new Promise((resolve, reject) => {
    context.$http.get(FOOD_INFO_URL + id, {params: {language}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getWeekCalendar = (context, userId, from) => {
  return new Promise((resolve, reject) => {
    context.$http.get(CALENDAR_PLAN_URL, {
      params: {
        userId: userId,
        from: from
      }
    })
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const updateWeekCalendar = (context, userId, from, items) => {
  return new Promise((resolve, reject) => {
    context.$http.post(CALENDAR_PLAN_URL, {
      userId: userId,
      from: from,
      items: items
    })
      .then((response) => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const hasNutritionPlan = (context, userId) => {
  return new Promise((resolve, reject) => {
    context.$http.get(USER_URL + '/nutritionPlan/' + userId)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const getNutritionPlanMode = (context, userId) => {
  return new Promise((resolve, reject) => {
    context.$http.get(USER_URL + '/nutritionPlan/' + userId + '/mode')
      .then((response) => {
        resolve(response.bodyText);
      }, error => {
        reject(error);
      });
  });
};

const updateNutritionPlanMode = (context, userId, mode) => {
  return new Promise((resolve, reject) => {
    context.$http.put(USER_URL + '/nutritionPlan/' + userId + '/mode', mode)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

export default {
  getPlans,
  getAllUserPlans,
  getTemplates,
  deletePlan,
  updatePlan,
  createPlan,
  getFoodList,
  getFoodInfo,
  getWeekCalendar,
  updateWeekCalendar,
  hasNutritionPlan,
  getNutritionPlanMode,
  updateNutritionPlanMode
};



// WEBPACK FOOTER //
// ./src/brand/health/api/nutritionPlan/index.js